import { Check } from "lucide-react";

// Renders an array of content blocks: strings become paragraphs,
// objects with { ul: [...] } become checkmark bullet lists.
export default function Blocks({ items = [], className = "", listAccent = "brand" }) {
  const dot = listAccent === "leaf" ? "text-leaf" : "text-brand";
  return (
    <div className={"space-y-4 " + className}>
      {items.map((block, i) => {
        if (typeof block === "string") {
          return (
            <p key={i} className="text-slate-600 leading-relaxed text-[17px]">
              {block}
            </p>
          );
        }
        if (block && block.ul) {
          return (
            <ul key={i} className="space-y-3 pt-1">
              {block.ul.map((li, j) => (
                <li key={j} className="flex gap-3 text-slate-700 leading-relaxed text-[17px]">
                  <span className={"mt-1 shrink-0 " + dot}>
                    <Check className="h-5 w-5" strokeWidth={2.5} />
                  </span>
                  <span>{li}</span>
                </li>
              ))}
            </ul>
          );
        }
        return null;
      })}
    </div>
  );
}
